import React from "react";
 import StablePrime from "../components/Tables/StablePrime";

function LinePerformancemob({ setPageHeader }) {
  setPageHeader("Line Performance");
  return (
    <div>
      <StablePrime url="lineperformancemob" data={{}} identity="perfparam" />
    </div>
  );
}

export default LinePerformancemob;
